import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { formatCurrency } from "../../../../utils/format";

/**
 * ServiceSidebar
 * Lista de Produtos e Serviços utilizando o componente padronizado NeoSideMenu.
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const ServiceSidebar = ({ items = [], activeId, onSelect, onCreateNew, loading }) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar produtos/serviços baseado na pesquisa local
    const filteredItems = items.filter((item) =>
        item.nameService?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear itens para o formato do NeoSideMenu
    const sideMenuItems = filteredItems.map((item) => ({
        id: item.id,
        label: item.nameService || "Sem Nome",
        description: `${item.type === 'product' ? 'Produto' : 'Serviço'} • ${formatCurrency(item.value)}`,
        icon: "mdi-package-variant-closed",
        badge: item.inactive ? "Inativo" : null,
        badgeVariant: item.inactive ? "muted" : null
    }));

    return (
        <NeoSideMenu
            title="Produtos e Serviços"
            subtitle="Itens disponíveis para venda"
            icon="mdi-package-variant-closed"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const item = items.find((i) => i.id === id);
                if (item) onSelect(item);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar produto ou serviço..."
                />
            }
        />
    );
};

ServiceSidebar.propTypes = {
    items: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func,
    onCreateNew: PropTypes.func,
    loading: PropTypes.bool
};

export default ServiceSidebar;
